import React, { Fragment } from "react";
import { Range } from "rc-slider";
import "rc-slider/assets/index.css";
const GPASlider = ({ handleGPASlider, minGPA, maxGPA, showFourPlus = false }) => {
  const markStyle = { width: "42px", textAlign: "center" };
  // Discrete GPA breakpoints for H/S query (shown evenly spaced)
  // Last value is a sentinel (> 4) so we can distinguish 4.0 vs 4.0+ in logic
  const hsValues = [0, 2.5, 2.75, 3, 3.25, 3.5, 3.75, 4, 4.01];

  const formatMarkLabel = (value, isPlus = false) => {
    if (isPlus) return "4.0+";
    if (value === 0) return "0";
    if (value >= 4) return "4.0";
    if (Number.isInteger(value)) return value.toFixed(1); // 3.0, 2.0 etc.
    return String(value);
  };

  const buildMarks = () => {
    const values = [];

    if (showFourPlus) {
      // H/S full: use index positions 0..N-1 so spacing is even,
      // but labels show real GPA values from hsValues
      hsValues.forEach((_, index) => values.push(index));
    } else {
      // CCC: show 0.5 increments only
      for (let v = 0; v <= 4; v += 0.5) {
        values.push(Number(v.toFixed(2)));
      }
    }

    return values.reduce((acc, v) => {
      if (showFourPlus) {
        const gpa = hsValues[v];
        const isLast = v === hsValues.length - 1;
        acc[v] = { style: markStyle, label: formatMarkLabel(gpa, isLast) };
      } else {
        // CCC: keep original simple labels like 0, 0.5, 1, ... 4
        acc[v] = { style: markStyle, label: String(v) };
      }
      return acc;
    }, {});
  };

  const marks = buildMarks();
  // In H/S mode, snap only to defined marks (indices 0..N-1); CCC uses 0.5 step over 0..4
  const step = showFourPlus ? 1 : 0.5;

  // Helpers to map between GPA values and index positions for H/S mode
  const mapGpaToIndex = (gpa) => {
    const numeric = typeof gpa === 'string' ? parseFloat(gpa) : gpa;
    if (Number.isNaN(numeric)) return 0;
    let bestIndex = 0;
    let bestDiff = Infinity;
    hsValues.forEach((v, idx) => {
      const diff = Math.abs(v - numeric);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestIndex = idx;
      }
    });
    return bestIndex;
  };

  const mapIndicesToGpa = (indices) => indices.map((i) => hsValues[i]);

  // Helper for displaying GPA in the right-hand summary boxes
  const formatBoxGpa = (value) => {
    if (!showFourPlus) return value;
    if (value >= 4.01) return "4.0+";
    if (value >= 4) return "4.0";
    return value;
  };

  return (
    <Fragment>
      <div style={{ width: "100%", marginTop: "0px" }}>
        <div className="query-title-containers ">
          <p style={{ marginBottom: "10px" }} className="bold">{`GPA Range`}</p>
        </div>
        <div
          className="col-md-12 row flex"
          style={{ margin: "0", alignItems: "center", padding: "10px 0" }}
        >
          <div className="col-md-6" style={{ paddingRight: "20px" }}>
            <Range
              step={step}
              defaultValue={
                showFourPlus
                  ? [mapGpaToIndex(minGPA), mapGpaToIndex(maxGPA)]
                  : [minGPA, maxGPA]
              }
              marks={marks}
              min={0}
              max={showFourPlus ? hsValues.length - 1 : 4}
              tipFormatter={(value) => (
                <span className="tooltip">
                  {showFourPlus
                    ? formatMarkLabel(
                        hsValues[value],
                        value === hsValues.length - 1
                      )
                    : value}
                </span>
              )}
              activeDotStyle={{ borderColor: "#009900" }}
              dotStyle={{ borderColor: "#e0e0e0" }}
              onChange={(value) =>
                handleGPASlider(showFourPlus ? mapIndicesToGpa(value) : value)
              }
            />
          </div>
          <div
            style={{ justifyContent: "space-evenly", alignItems: "center" }}
            className="col-md-6 flex"
          >
            <div className="gpa-display-box">
              <p className="gpa-label">Minimum GPA</p>
              <p className="gpa-value">{formatBoxGpa(minGPA)}</p>
            </div>
            <div className="gpa-to-text">To</div>
            <div className="gpa-display-box">
              <p className="gpa-label">Maximum GPA</p>
              <p className="gpa-value">{formatBoxGpa(maxGPA)}</p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default GPASlider;
